import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'trial.booking.bookedDescription': "Check your inbox, accept the invite, and we'll see you soon!",
  'trial.booking.bookedSnackbar': 'Your demo is booked — see you there!',
  'trial.booking.bookedTitle': 'Your demo is booked!',
  'trial.booking.calendarSubtitle':
    "You'll get a personalized walkthrough of the product, hear proven customer success stories, and learn about pricing for your use case.",
  'trial.booking.calendarTitle': 'Book your 30-minute Rask demo',
  'trial.booking.done': 'Done',
  'trial.booking.maybeLater': 'Maybe later',
  'trial.demo.description':
    'Select a target translation language and check out the result. Make changes and adjust voices to explore the editor features.',
  'trial.demo.openEditor': 'Open in editor',
  'trial.demo.paidLanguages': 'Languages available on paid plans',
  'trial.demo.projectLabel': 'Demo project',
  'trial.demo.title': 'Try the Demo Project for free!',
  'trial.demo.translateOwnVideo': 'Translate your own video',
  'trial.demoBanner.delegate.cta': 'Let us handle it',
  'trial.demoBanner.delegate.subtitle': 'See exactly how on a 30-minute call with our team.',
  'trial.demoBanner.delegate.title': 'Want to delegate your localization work to us?',
  'trial.demoBanner.integration.cta': 'I need an integration',
  'trial.demoBanner.integration.subtitle': 'Book a 1:1 demo — we’ll take it from there.',
  'trial.demoBanner.integration.title': 'Integrate Rask into your workflow hassle-free',
  'trial.demoBanner.volume.cta': 'Cut costs and effort',
  'trial.demoBanner.volume.subtitle': 'Book a 1:1 demo — we’ll build your localization plan.',
  'trial.demoBanner.volume.title': 'Producing serious volume?',
  'trial.landing.durationMinutes': '{count} min',
  'trial.landing.durationSeconds': '{count} sec',
  'trial.landing.fileFallback': 'Your file',
  'trial.landing.localizing': 'Localizing',
  'trial.landing.previewAlt': 'Preview',
  'trial.landing.uploaded': 'Uploaded',
  'trial.player.enterFullscreen': 'Enter fullscreen',
  'trial.player.exitFullscreen': 'Exit fullscreen',
  'trial.player.lipSync': 'Lip-sync',
  'trial.player.localized': 'Localized',
  'trial.player.mute': 'Mute',
  'trial.player.original': 'Original',
  'trial.player.pause': 'Pause',
  'trial.player.pauseVideo': 'Pause video',
  'trial.player.play': 'Play',
  'trial.player.playVideo': 'Play video',
  'trial.player.previewAria': '{name} video preview',
  'trial.player.seek': 'Seek',
  'trial.player.unmute': 'Unmute',
  'trial.player.upgrade.continueWatching': 'Continue watching',
  'trial.player.upgrade.lockedSubtitle':
    'We translated the first minute. Upgrade to translate the whole video — full length, no watermark.',
  'trial.player.upgrade.lockedTitle': "That's the preview — unlock the full video",
  'trial.player.upgrade.oneMinutePreview': '1-minute preview',
  'trial.player.upgrade.overlaySubtitle':
    'Enjoying the preview? Upgrade to translate your whole video — full length, no watermark.',
  'trial.player.upgrade.overlayTitle': 'Upgrade to translate the full video',
  'trial.player.upgrade.replay': 'Replay preview',
  'trial.player.upgrade.seePlans': 'See plans',
  'trial.player.upgrade.upgrade': 'Upgrade',
  'trial.player.videoLanguage': 'Video language',
  'trial.player.videoProgress': 'Video progress',
  'trial.preview.editorDescription': 'Refine the script, voices, and timing yourself.',
  'trial.preview.editorTitle': 'Explore in the editor',
  'trial.preview.export': 'Export',
  'trial.preview.exportDescription': 'Download the localized MP4 with dubbed audio and subtitles.',
  'trial.preview.exportTitle': 'Export your video',
  'trial.preview.openEditor': 'Open editor',
  'trial.preview.talkToSales': 'Talk to sales about volume dubbing',
  'trial.processing.audioReady': 'Your file is ready',
  'trial.processing.audioReadyDescription': 'Your localized file is ready to view.',
  'trial.processing.completeAnnouncement': 'Localization complete. All processing steps finished.',
  'trial.processing.currentStepAnnouncement': 'Current processing step: {step}',
  'trial.processing.localizedInto': 'Localized into {language}',
  'trial.processing.localizingAudio': 'Localizing your file',
  'trial.processing.localizingInto': 'Localizing into {language}',
  'trial.processing.localizingVideo': 'Localizing your video',
  'trial.processing.progressAria': 'Localization progress: {percent}%',
  'trial.processing.steps.backgroundAudio.description': 'Preserving music and ambience underneath.',
  'trial.processing.steps.backgroundAudio.title': 'Kept the background audio',
  'trial.processing.steps.speaker.description': "Separating each speaker's voice from the background mix.",
  'trial.processing.steps.speaker.title': 'Identified the speakers',
  'trial.processing.steps.timing.description': 'Matching every line to the on-screen delivery.',
  'trial.processing.steps.timing.title': 'Synced with original timing',
  'trial.processing.steps.translation.description':
    'Localizing idioms, tone and phrasing for the audience — not word-for-word.',
  'trial.processing.steps.translation.title': 'Translated to the target language',
  'trial.processing.steps.translation.titleWithLanguage': 'Translated to {language}',
  'trial.processing.steps.voice.description': "Rebuilding each speaker's tone in the new language.",
  'trial.processing.steps.voice.title': "Cloned each speaker's voice",
  'trial.processing.videoReady': 'Your video is ready',
  'trial.processing.videoReadyDescription': 'Your localized video is ready to view.',
  'trial.processing.waitDescription': "This takes about a minute — hang tight, we'll show you the result here.",
  'trial.processing.workingOnAudio': 'Working on your file',
  'trial.processing.workingOnVideo': 'Working on your video',
  'trial.publicShare.branding': 'Localized with Rask',
  'trial.publicShare.ctaQuestion': 'Want to localize your own video?',
  'trial.publicShare.description': 'Watch it in the original language, or switch to the localized version.',
  'trial.publicShare.heading': 'This video was localized with Rask',
  'trial.publicShare.loadErrorDescription': 'Please refresh the page or try again in a few moments.',
  'trial.publicShare.loadErrorTitle': 'Unable to load this video',
  'trial.publicShare.loading': 'Loading video…',
  'trial.publicShare.loadingAria': 'Loading shared video',
  'trial.publicShare.metaTitle': 'Localized video',
  'trial.publicShare.noCard': 'Localize a video into 135+ languages — no card required.',
  'trial.publicShare.playerAria': '{name} video player',
  'trial.publicShare.raskHome': 'Rask home',
  'trial.publicShare.sharedVideo': 'Shared',
  'trial.publicShare.tryFree': 'Try Rask free',
  'trial.publicShare.viewPlans': 'View plans',
  'trial.share.button': 'Share',
  'trial.share.copied': 'Copied!',
  'trial.share.copy': 'Copy',
  'trial.share.description': 'Send your video to anyone using the link below',
  'trial.share.error': 'Something went wrong. Please try again later.',
  'trial.share.title': 'Share your video',
  'trial.sidebarBanner.cta': 'Upgrade to full version',
  'trial.sidebarBanner.title': 'Unlock advanced features and take your video translations to the next level!',
  'trial.survey.continue': 'Continue',
  'trial.survey.continueAnyway': 'Continue anyway',
  'trial.survey.footnote': 'Takes 5 seconds · helps us set you up right',
  'trial.survey.hours.fifteenToThirty': '15–30 hours',
  'trial.survey.hours.lessThanOne': 'Less than 1 hour',
  'trial.survey.hours.moreThanThirty': 'More than 30 hours',
  'trial.survey.hours.oneToTen': '1–10 hours',
  'trial.survey.hours.tenToFifteen': '10–15 hours',
  'trial.survey.hoursPlaceholder': 'Select volume',
  'trial.survey.hoursQuestion': 'How many hours of video do you work with per month?',
  'trial.survey.languagesPlaceholder': 'Select a number of languages',
  'trial.survey.languagesQuestion': 'How many languages does your audience speak?',
  'trial.survey.submitError': "Couldn't save your answers. Please try again.",
  'trial.survey.subtitle': 'Two quick questions so we can tailor your workspace.',
  'trial.survey.title': 'Welcome to Rask',
} as const;

type TrialTranslation = Record<keyof typeof en, string>;

const es = {
  'trial.booking.bookedDescription': 'Revisa tu bandeja de entrada, acepta la invitación y nos vemos pronto.',
  'trial.booking.bookedSnackbar': 'Tu demo está reservada. ¡Nos vemos!',
  'trial.booking.bookedTitle': '¡Tu demo está reservada!',
  'trial.booking.calendarSubtitle':
    'Recibirás una demostración personalizada del producto, conocerás casos de éxito de clientes y los precios para tu caso de uso.',
  'trial.booking.calendarTitle': 'Reserva tu demo de Rask de 30 minutos',
  'trial.booking.done': 'Listo',
  'trial.booking.maybeLater': 'Quizá más tarde',
  'trial.demo.description':
    'Selecciona el idioma de destino y comprueba el resultado. Haz cambios y ajusta las voces para explorar el editor.',
  'trial.demo.openEditor': 'Abrir en el editor',
  'trial.demo.paidLanguages': 'Idiomas disponibles en los planes de pago',
  'trial.demo.projectLabel': 'Proyecto de demostración',
  'trial.demo.title': '¡Prueba gratis el proyecto de demostración!',
  'trial.demo.translateOwnVideo': 'Traduce tu propio video',
  'trial.demoBanner.delegate.cta': 'Deja que nos encarguemos',
  'trial.demoBanner.delegate.subtitle': 'Descubre cómo en una llamada de 30 minutos con nuestro equipo.',
  'trial.demoBanner.delegate.title': '¿Quieres delegarnos la adaptación?',
  'trial.demoBanner.integration.cta': 'Necesito una integración',
  'trial.demoBanner.integration.subtitle': 'Reserva una demo individual y nosotros nos encargaremos del resto.',
  'trial.demoBanner.integration.title': 'Integra Rask fácilmente en tu flujo de trabajo',
  'trial.demoBanner.volume.cta': 'Reduce costes y esfuerzo',
  'trial.demoBanner.volume.subtitle': 'Reserva una demo individual y crearemos tu plan de adaptación.',
  'trial.demoBanner.volume.title': '¿Produces grandes volúmenes?',
  'trial.landing.durationMinutes': '{count} min',
  'trial.landing.durationSeconds': '{count} s',
  'trial.landing.fileFallback': 'Tu archivo',
  'trial.landing.localizing': 'Adaptando',
  'trial.landing.previewAlt': 'Vista previa',
  'trial.landing.uploaded': 'Subido',
  'trial.player.enterFullscreen': 'Entrar en pantalla completa',
  'trial.player.exitFullscreen': 'Salir de pantalla completa',
  'trial.player.lipSync': 'Lip-sync',
  'trial.player.localized': 'Adaptado',
  'trial.player.mute': 'Silenciar',
  'trial.player.original': 'Original',
  'trial.player.pause': 'Pausar',
  'trial.player.pauseVideo': 'Pausar video',
  'trial.player.play': 'Reproducir',
  'trial.player.playVideo': 'Reproducir video',
  'trial.player.previewAria': 'Vista previa del video {name}',
  'trial.player.seek': 'Desplazarse por el video',
  'trial.player.unmute': 'Activar sonido',
  'trial.player.upgrade.continueWatching': 'Seguir viendo',
  'trial.player.upgrade.lockedSubtitle':
    'Hemos traducido el primer minuto. Mejora tu plan para traducir el video completo y sin marca de agua.',
  'trial.player.upgrade.lockedTitle': 'Hasta aquí llega la vista previa: desbloquea el video completo',
  'trial.player.upgrade.oneMinutePreview': 'Vista previa de 1 minuto',
  'trial.player.upgrade.overlaySubtitle':
    '¿Te gusta la vista previa? Mejora tu plan para traducir el video completo y sin marca de agua.',
  'trial.player.upgrade.overlayTitle': 'Mejora tu plan para traducir el video completo',
  'trial.player.upgrade.replay': 'Volver a reproducir',
  'trial.player.upgrade.seePlans': 'Ver planes',
  'trial.player.upgrade.upgrade': 'Mejorar plan',
  'trial.player.videoLanguage': 'Versión del video',
  'trial.player.videoProgress': 'Progreso del video',
  'trial.preview.editorDescription': 'Ajusta por tu cuenta el guion, las voces y los tiempos.',
  'trial.preview.editorTitle': 'Explorar en el editor',
  'trial.preview.export': 'Exportar',
  'trial.preview.exportDescription': 'Descarga el MP4 adaptado con audio doblado y subtítulos.',
  'trial.preview.exportTitle': 'Exporta tu video',
  'trial.preview.openEditor': 'Abrir el editor',
  'trial.preview.talkToSales': 'Habla con ventas sobre doblaje a gran escala',
  'trial.processing.audioReady': 'Tu archivo está listo',
  'trial.processing.audioReadyDescription': 'Tu archivo adaptado está listo para verlo.',
  'trial.processing.completeAnnouncement': 'Adaptación completada. Todos los pasos han finalizado.',
  'trial.processing.currentStepAnnouncement': 'Paso de procesamiento actual: {step}',
  'trial.processing.localizedInto': 'Adaptado al {language}',
  'trial.processing.localizingAudio': 'Adaptando tu archivo',
  'trial.processing.localizingInto': 'Adaptando al {language}',
  'trial.processing.localizingVideo': 'Adaptando tu video',
  'trial.processing.progressAria': 'Progreso de adaptación: {percent} %',
  'trial.processing.steps.backgroundAudio.description': 'Conservando la música y el sonido ambiente.',
  'trial.processing.steps.backgroundAudio.title': 'Audio de fondo conservado',
  'trial.processing.steps.speaker.description': 'Separando la voz de cada hablante de la mezcla de fondo.',
  'trial.processing.steps.speaker.title': 'Hablantes identificados',
  'trial.processing.steps.timing.description': 'Ajustando cada frase a la intervención en pantalla.',
  'trial.processing.steps.timing.title': 'Sincronizado con los tiempos originales',
  'trial.processing.steps.translation.description':
    'Adaptando expresiones, tono y redacción a la audiencia, no palabra por palabra.',
  'trial.processing.steps.translation.title': 'Traducido al idioma de destino',
  'trial.processing.steps.translation.titleWithLanguage': 'Traducido al {language}',
  'trial.processing.steps.voice.description': 'Recreando el tono de cada hablante en el nuevo idioma.',
  'trial.processing.steps.voice.title': 'Voz de cada hablante clonada',
  'trial.processing.videoReady': 'Tu video está listo',
  'trial.processing.videoReadyDescription': 'Tu video adaptado está listo para verlo.',
  'trial.processing.waitDescription': 'Tardará alrededor de un minuto. Te mostraremos aquí el resultado.',
  'trial.processing.workingOnAudio': 'Trabajando en tu archivo',
  'trial.processing.workingOnVideo': 'Trabajando en tu video',
  'trial.publicShare.branding': 'Adaptado con Rask',
  'trial.publicShare.ctaQuestion': '¿Quieres adaptar tu propio video?',
  'trial.publicShare.description': 'Míralo en el idioma original o cambia a la versión adaptada.',
  'trial.publicShare.heading': 'Este video se ha adaptado con Rask',
  'trial.publicShare.loadErrorDescription': 'Actualiza la página o inténtalo de nuevo dentro de unos instantes.',
  'trial.publicShare.loadErrorTitle': 'No se puede cargar este video',
  'trial.publicShare.loading': 'Cargando video…',
  'trial.publicShare.loadingAria': 'Cargando video compartido',
  'trial.publicShare.metaTitle': 'Video adaptado',
  'trial.publicShare.noCard': 'Adapta un video a más de 135 idiomas sin tarjeta.',
  'trial.publicShare.playerAria': 'Reproductor de video {name}',
  'trial.publicShare.raskHome': 'Inicio de Rask',
  'trial.publicShare.sharedVideo': 'compartido',
  'trial.publicShare.tryFree': 'Prueba Rask gratis',
  'trial.publicShare.viewPlans': 'Ver planes',
  'trial.share.button': 'Compartir',
  'trial.share.copied': '¡Copiado!',
  'trial.share.copy': 'Copiar',
  'trial.share.description': 'Envía tu video a quien quieras con el siguiente enlace',
  'trial.share.error': 'Algo salió mal. Inténtalo de nuevo más tarde.',
  'trial.share.title': 'Comparte tu video',
  'trial.sidebarBanner.cta': 'Actualizar a la versión completa',
  'trial.sidebarBanner.title': 'Desbloquea funciones avanzadas y lleva tus traducciones de video al siguiente nivel.',
  'trial.survey.continue': 'Continuar',
  'trial.survey.continueAnyway': 'Continuar de todos modos',
  'trial.survey.footnote': 'Tarda 5 segundos · nos ayuda a configurar bien tu espacio',
  'trial.survey.hours.fifteenToThirty': '15–30 horas',
  'trial.survey.hours.lessThanOne': 'Menos de 1 hora',
  'trial.survey.hours.moreThanThirty': 'Más de 30 horas',
  'trial.survey.hours.oneToTen': '1–10 horas',
  'trial.survey.hours.tenToFifteen': '10–15 horas',
  'trial.survey.hoursPlaceholder': 'Selecciona el volumen',
  'trial.survey.hoursQuestion': '¿Qué tamaño tiene tu videoteca actual?',
  'trial.survey.languagesPlaceholder': 'Selecciona el número de idiomas',
  'trial.survey.languagesQuestion': '¿Cuántos idiomas habla tu audiencia?',
  'trial.survey.submitError': 'No se han podido guardar tus respuestas. Inténtalo de nuevo.',
  'trial.survey.subtitle': 'Dos preguntas rápidas para adaptar tu espacio de trabajo.',
  'trial.survey.title': 'Te damos la bienvenida a Rask',
} satisfies TrialTranslation;

const pt = {
  'trial.booking.bookedDescription': 'Confira sua caixa de entrada, aceite o convite e nos vemos em breve!',
  'trial.booking.bookedSnackbar': 'Sua demonstração está agendada — até lá!',
  'trial.booking.bookedTitle': 'Sua demonstração está agendada!',
  'trial.booking.calendarSubtitle':
    'Você receberá uma apresentação personalizada do produto, conhecerá histórias comprovadas de sucesso de clientes e saberá mais sobre os preços para seu caso de uso.',
  'trial.booking.calendarTitle': 'Agende sua demonstração de 30 minutos do Rask',
  'trial.booking.done': 'Pronto',
  'trial.booking.maybeLater': 'Talvez mais tarde',
  'trial.demo.description':
    'Selecione o idioma de destino e confira o resultado. Faça alterações e ajuste as vozes para explorar o editor.',
  'trial.demo.openEditor': 'Abrir no editor',
  'trial.demo.paidLanguages': 'Idiomas disponíveis nos planos pagos',
  'trial.demo.projectLabel': 'Projeto de demonstração',
  'trial.demo.title': 'Experimente grátis o projeto de demonstração!',
  'trial.demo.translateOwnVideo': 'Traduza seu próprio vídeo',
  'trial.demoBanner.delegate.cta': 'Deixe com a gente',
  'trial.demoBanner.delegate.subtitle': 'Veja como em uma chamada de 30 minutos com nossa equipe.',
  'trial.demoBanner.delegate.title': 'Quer delegar seu trabalho de adaptação para nós?',
  'trial.demoBanner.integration.cta': 'Preciso de integração',
  'trial.demoBanner.integration.subtitle': 'Agende uma demonstração individual e cuidaremos do restante.',
  'trial.demoBanner.integration.title': 'Integre o Rask facilmente ao seu fluxo de trabalho',
  'trial.demoBanner.volume.cta': 'Reduza custos e esforço',
  'trial.demoBanner.volume.subtitle': 'Agende uma demonstração individual e criaremos seu plano de adaptação.',
  'trial.demoBanner.volume.title': 'Produz um grande volume de conteúdo?',
  'trial.landing.durationMinutes': '{count} min',
  'trial.landing.durationSeconds': '{count} s',
  'trial.landing.fileFallback': 'Seu arquivo',
  'trial.landing.localizing': 'Adaptando',
  'trial.landing.previewAlt': 'Prévia',
  'trial.landing.uploaded': 'Enviado',
  'trial.player.enterFullscreen': 'Entrar em tela cheia',
  'trial.player.exitFullscreen': 'Sair da tela cheia',
  'trial.player.lipSync': 'Lip-sync',
  'trial.player.localized': 'Adaptado',
  'trial.player.mute': 'Desativar som',
  'trial.player.original': 'Original',
  'trial.player.pause': 'Pausar',
  'trial.player.pauseVideo': 'Pausar vídeo',
  'trial.player.play': 'Reproduzir',
  'trial.player.playVideo': 'Reproduzir vídeo',
  'trial.player.previewAria': 'Prévia do vídeo {name}',
  'trial.player.seek': 'Navegar pelo vídeo',
  'trial.player.unmute': 'Ativar som',
  'trial.player.upgrade.continueWatching': 'Continuar assistindo',
  'trial.player.upgrade.lockedSubtitle':
    'Traduzimos o primeiro minuto. Faça upgrade para traduzir o vídeo completo, sem marca-d’água.',
  'trial.player.upgrade.lockedTitle': 'A prévia termina aqui — desbloqueie o vídeo completo',
  'trial.player.upgrade.oneMinutePreview': 'Prévia de 1 minuto',
  'trial.player.upgrade.overlaySubtitle':
    'Gostou da prévia? Faça upgrade para traduzir o vídeo completo, sem marca-d’água.',
  'trial.player.upgrade.overlayTitle': 'Faça upgrade para traduzir o vídeo completo',
  'trial.player.upgrade.replay': 'Reproduzir prévia novamente',
  'trial.player.upgrade.seePlans': 'Ver planos',
  'trial.player.upgrade.upgrade': 'Fazer upgrade',
  'trial.player.videoLanguage': 'Idioma do vídeo',
  'trial.player.videoProgress': 'Progresso do vídeo',
  'trial.preview.editorDescription': 'Ajuste por conta própria o roteiro, as vozes e a sincronização.',
  'trial.preview.editorTitle': 'Explorar no editor',
  'trial.preview.export': 'Exportar',
  'trial.preview.exportDescription': 'Baixe o MP4 adaptado com áudio dublado e legendas.',
  'trial.preview.exportTitle': 'Exporte seu vídeo',
  'trial.preview.openEditor': 'Abrir o editor',
  'trial.preview.talkToSales': 'Fale com a equipe de vendas sobre dublagem em grande escala',
  'trial.processing.audioReady': 'Seu arquivo está pronto',
  'trial.processing.audioReadyDescription': 'Seu arquivo adaptado está pronto para ser visualizado.',
  'trial.processing.completeAnnouncement': 'Adaptação concluída. Todas as etapas foram finalizadas.',
  'trial.processing.currentStepAnnouncement': 'Etapa atual do processamento: {step}',
  'trial.processing.localizedInto': 'Adaptado para {language}',
  'trial.processing.localizingAudio': 'Adaptando seu arquivo',
  'trial.processing.localizingInto': 'Adaptando para {language}',
  'trial.processing.localizingVideo': 'Adaptando seu vídeo',
  'trial.processing.progressAria': 'Progresso da adaptação: {percent}%',
  'trial.processing.steps.backgroundAudio.description': 'Preservando música e som ambiente.',
  'trial.processing.steps.backgroundAudio.title': 'Áudio de fundo preservado',
  'trial.processing.steps.speaker.description': 'Separando a voz de cada locutor da mixagem de fundo.',
  'trial.processing.steps.speaker.title': 'Locutores identificados',
  'trial.processing.steps.timing.description': 'Sincronizando cada fala com o momento em que é dita no vídeo.',
  'trial.processing.steps.timing.title': 'Sincronizado com o tempo original',
  'trial.processing.steps.translation.description':
    'Adaptando expressões, tom e texto ao público, em vez de traduzir palavra por palavra.',
  'trial.processing.steps.translation.title': 'Traduzido para o idioma de destino',
  'trial.processing.steps.translation.titleWithLanguage': 'Traduzido para {language}',
  'trial.processing.steps.voice.description': 'Recriando o tom de cada locutor no novo idioma.',
  'trial.processing.steps.voice.title': 'Voz de cada locutor clonada',
  'trial.processing.videoReady': 'Seu vídeo está pronto',
  'trial.processing.videoReadyDescription': 'Seu vídeo adaptado está pronto para ser visualizado.',
  'trial.processing.waitDescription': 'Isso leva cerca de um minuto. Mostraremos o resultado aqui.',
  'trial.processing.workingOnAudio': 'Trabalhando no seu arquivo',
  'trial.processing.workingOnVideo': 'Trabalhando no seu vídeo',
  'trial.publicShare.branding': 'Adaptado com o Rask',
  'trial.publicShare.ctaQuestion': 'Quer adaptar seu próprio vídeo?',
  'trial.publicShare.description': 'Assista no idioma original ou mude para a versão adaptada.',
  'trial.publicShare.heading': 'Este vídeo foi adaptado com o Rask',
  'trial.publicShare.loadErrorDescription': 'Atualize a página ou tente novamente em alguns instantes.',
  'trial.publicShare.loadErrorTitle': 'Não foi possível carregar este vídeo',
  'trial.publicShare.loading': 'Carregando vídeo…',
  'trial.publicShare.loadingAria': 'Carregando vídeo compartilhado',
  'trial.publicShare.metaTitle': 'Vídeo adaptado',
  'trial.publicShare.noCard': 'Adapte vídeos para mais de 135 idiomas sem cartão.',
  'trial.publicShare.playerAria': 'Player de vídeo {name}',
  'trial.publicShare.raskHome': 'Página inicial do Rask',
  'trial.publicShare.sharedVideo': 'Compartilhado',
  'trial.publicShare.tryFree': 'Experimente o Rask grátis',
  'trial.publicShare.viewPlans': 'Ver planos',
  'trial.share.button': 'Compartilhar',
  'trial.share.copied': 'Copiado!',
  'trial.share.copy': 'Copiar',
  'trial.share.description': 'Envie seu vídeo para qualquer pessoa usando o link abaixo',
  'trial.share.error': 'Algo deu errado. Tente novamente mais tarde.',
  'trial.share.title': 'Compartilhe seu vídeo',
  'trial.sidebarBanner.cta': 'Fazer upgrade para a versão completa',
  'trial.sidebarBanner.title': 'Libere recursos avançados e leve suas traduções de vídeo a outro nível!',
  'trial.survey.continue': 'Continuar',
  'trial.survey.continueAnyway': 'Continuar mesmo assim',
  'trial.survey.footnote': 'Leva 5 segundos · ajuda a configurar seu espaço de trabalho corretamente',
  'trial.survey.hours.fifteenToThirty': '15–30 horas',
  'trial.survey.hours.lessThanOne': 'Menos de 1 hora',
  'trial.survey.hours.moreThanThirty': 'Mais de 30 horas',
  'trial.survey.hours.oneToTen': '1–10 horas',
  'trial.survey.hours.tenToFifteen': '10–15 horas',
  'trial.survey.hoursPlaceholder': 'Selecione o volume',
  'trial.survey.hoursQuestion': 'Qual é o tamanho da sua biblioteca de vídeos atual?',
  'trial.survey.languagesPlaceholder': 'Selecione o número de idiomas',
  'trial.survey.languagesQuestion': 'Quantos idiomas seu público fala?',
  'trial.survey.submitError': 'Não foi possível salvar suas respostas. Tente novamente.',
  'trial.survey.subtitle': 'Duas perguntas rápidas para adaptar seu espaço de trabalho.',
  'trial.survey.title': 'Bem-vindo ao Rask',
} satisfies TrialTranslation;

const fr = {
  'trial.booking.bookedDescription': 'Consultez votre messagerie, acceptez l’invitation et à très bientôt !',
  'trial.booking.bookedSnackbar': 'Votre démo est réservée — à bientôt !',
  'trial.booking.bookedTitle': 'Votre démo est réservée !',
  'trial.booking.calendarSubtitle':
    'Vous bénéficierez d’une présentation personnalisée, découvrirez des réussites clients et les tarifs adaptés à votre usage.',
  'trial.booking.calendarTitle': 'Réservez votre démo Rask de 30 minutes',
  'trial.booking.done': 'Terminé',
  'trial.booking.maybeLater': 'Peut-être plus tard',
  'trial.demo.description':
    'Sélectionnez la langue cible et découvrez le résultat. Modifiez le contenu et ajustez les voix pour explorer l’éditeur.',
  'trial.demo.openEditor': "Ouvrir dans l'éditeur",
  'trial.demo.paidLanguages': 'Langues disponibles avec les offres payantes',
  'trial.demo.projectLabel': 'Projet de démonstration',
  'trial.demo.title': 'Essayez gratuitement le projet de démonstration !',
  'trial.demo.translateOwnVideo': 'Traduire votre propre vidéo',
  'trial.demoBanner.delegate.cta': 'Confiez-nous cette tâche',
  'trial.demoBanner.delegate.subtitle': 'Découvrez comment lors d’un appel de 30 minutes avec notre équipe.',
  'trial.demoBanner.delegate.title': 'Vous souhaitez nous confier l’adaptation de vos contenus ?',
  'trial.demoBanner.integration.cta': "J'ai besoin d'une intégration",
  'trial.demoBanner.integration.subtitle': 'Réservez une démo individuelle, nous nous occupons du reste.',
  'trial.demoBanner.integration.title': 'Intégrez facilement Rask à votre flux de travail',
  'trial.demoBanner.volume.cta': 'Réduire les coûts et les efforts',
  'trial.demoBanner.volume.subtitle': 'Réservez une démo individuelle — nous élaborerons votre plan d’adaptation.',
  'trial.demoBanner.volume.title': 'Vous produisez de gros volumes ?',
  'trial.landing.durationMinutes': '{count} min',
  'trial.landing.durationSeconds': '{count} s',
  'trial.landing.fileFallback': 'Votre fichier',
  'trial.landing.localizing': 'Adaptation en cours',
  'trial.landing.previewAlt': 'Aperçu',
  'trial.landing.uploaded': 'Importé',
  'trial.player.enterFullscreen': 'Passer en plein écran',
  'trial.player.exitFullscreen': 'Quitter le plein écran',
  'trial.player.lipSync': 'Lip-sync',
  'trial.player.localized': 'Adaptée',
  'trial.player.mute': 'Couper le son',
  'trial.player.original': 'Originale',
  'trial.player.pause': 'Mettre en pause',
  'trial.player.pauseVideo': 'Mettre la vidéo en pause',
  'trial.player.play': 'Lire',
  'trial.player.playVideo': 'Lire la vidéo',
  'trial.player.previewAria': 'Aperçu de la vidéo « {name} »',
  'trial.player.seek': 'Parcourir la vidéo',
  'trial.player.unmute': 'Activer le son',
  'trial.player.upgrade.continueWatching': 'Continuer à regarder',
  'trial.player.upgrade.lockedSubtitle':
    'Nous avons traduit la première minute. Passez à une offre supérieure pour traduire toute la vidéo, sans filigrane.',
  'trial.player.upgrade.lockedTitle': 'Fin de l’aperçu — débloquez la vidéo complète',
  'trial.player.upgrade.oneMinutePreview': 'Aperçu de 1 minute',
  'trial.player.upgrade.overlaySubtitle':
    'Cet aperçu vous plaît ? Passez à une offre supérieure pour traduire toute la vidéo, sans filigrane.',
  'trial.player.upgrade.overlayTitle': 'Passez à une offre supérieure pour traduire toute la vidéo',
  'trial.player.upgrade.replay': 'Revoir l’aperçu',
  'trial.player.upgrade.seePlans': 'Voir les offres',
  'trial.player.upgrade.upgrade': 'Passer à une offre supérieure',
  'trial.player.videoLanguage': 'Langue de la vidéo',
  'trial.player.videoProgress': 'Progression de la vidéo',
  'trial.preview.editorDescription': 'Ajustez vous-même le script, les voix et la synchronisation.',
  'trial.preview.editorTitle': "Explorer dans l'éditeur",
  'trial.preview.export': 'Exporter',
  'trial.preview.exportDescription': 'Téléchargez le MP4 adapté avec le doublage et les sous-titres.',
  'trial.preview.exportTitle': 'Exporter votre vidéo',
  'trial.preview.openEditor': "Ouvrir l'éditeur",
  'trial.preview.talkToSales': 'Parler à notre équipe commerciale du doublage à grande échelle',
  'trial.processing.audioReady': 'Votre fichier est prêt',
  'trial.processing.audioReadyDescription': 'Votre fichier adapté est prêt à être consulté.',
  'trial.processing.completeAnnouncement': 'Adaptation terminée. Toutes les étapes sont terminées.',
  'trial.processing.currentStepAnnouncement': 'Étape de traitement actuelle : {step}',
  'trial.processing.localizedInto': 'Adapté en {language}',
  'trial.processing.localizingAudio': 'Adaptation de votre fichier',
  'trial.processing.localizingInto': 'Adaptation en {language}',
  'trial.processing.localizingVideo': 'Adaptation de votre vidéo',
  'trial.processing.progressAria': 'Progression de l’adaptation : {percent} %',
  'trial.processing.steps.backgroundAudio.description': 'Conservation de la musique et de l’ambiance sonore.',
  'trial.processing.steps.backgroundAudio.title': 'Fond sonore conservé',
  'trial.processing.steps.speaker.description': 'Séparation de chaque voix du mixage de fond.',
  'trial.processing.steps.speaker.title': 'Intervenants identifiés',
  'trial.processing.steps.timing.description': 'Synchronisation de chaque phrase avec l’intervention à l’écran.',
  'trial.processing.steps.timing.title': 'Synchronisé avec le minutage original',
  'trial.processing.steps.translation.description':
    'Adaptation des expressions, du ton et de la formulation au public, sans traduction littérale.',
  'trial.processing.steps.translation.title': 'Traduit dans la langue cible',
  'trial.processing.steps.translation.titleWithLanguage': 'Traduit en {language}',
  'trial.processing.steps.voice.description': 'Recréation du timbre de chaque intervenant dans la nouvelle langue.',
  'trial.processing.steps.voice.title': 'Voix de chaque intervenant clonée',
  'trial.processing.videoReady': 'Votre vidéo est prête',
  'trial.processing.videoReadyDescription': 'Votre vidéo adaptée est prête à être regardée.',
  'trial.processing.waitDescription': 'Cela prend environ une minute. Le résultat apparaîtra ici.',
  'trial.processing.workingOnAudio': 'Traitement de votre fichier',
  'trial.processing.workingOnVideo': 'Traitement de votre vidéo',
  'trial.publicShare.branding': 'Adaptée avec Rask',
  'trial.publicShare.ctaQuestion': 'Vous souhaitez adapter votre propre vidéo ?',
  'trial.publicShare.description': 'Regardez-la dans sa langue originale ou passez à la version adaptée.',
  'trial.publicShare.heading': 'Cette vidéo a été adaptée avec Rask',
  'trial.publicShare.loadErrorDescription': 'Actualisez la page ou réessayez dans quelques instants.',
  'trial.publicShare.loadErrorTitle': 'Impossible de charger cette vidéo',
  'trial.publicShare.loading': 'Chargement de la vidéo…',
  'trial.publicShare.loadingAria': 'Chargement de la vidéo partagée',
  'trial.publicShare.metaTitle': 'Vidéo adaptée',
  'trial.publicShare.noCard': 'Adaptez vos vidéos dans plus de 135 langues, sans carte bancaire.',
  'trial.publicShare.playerAria': 'Lecteur vidéo {name}',
  'trial.publicShare.raskHome': 'Accueil de Rask',
  'trial.publicShare.sharedVideo': 'partagée',
  'trial.publicShare.tryFree': 'Essayer Rask gratuitement',
  'trial.publicShare.viewPlans': 'Voir les offres',
  'trial.share.button': 'Partager',
  'trial.share.copied': 'Copié !',
  'trial.share.copy': 'Copier',
  'trial.share.description': 'Envoyez votre vidéo grâce au lien ci-dessous',
  'trial.share.error': 'Une erreur est survenue. Veuillez réessayer plus tard.',
  'trial.share.title': 'Partager votre vidéo',
  'trial.sidebarBanner.cta': 'Passer à la version complète',
  'trial.sidebarBanner.title': 'Débloquez les fonctions avancées et améliorez vos traductions vidéo !',
  'trial.survey.continue': 'Continuer',
  'trial.survey.continueAnyway': 'Continuer quand même',
  'trial.survey.footnote': '5 secondes suffisent pour mieux vous accompagner',
  'trial.survey.hours.fifteenToThirty': '15 à 30 heures',
  'trial.survey.hours.lessThanOne': "Moins d'une heure",
  'trial.survey.hours.moreThanThirty': 'Plus de 30 heures',
  'trial.survey.hours.oneToTen': '1 à 10 heures',
  'trial.survey.hours.tenToFifteen': '10 à 15 heures',
  'trial.survey.hoursPlaceholder': 'Sélectionnez un volume',
  'trial.survey.hoursQuestion': 'Quelle est la taille de votre vidéothèque actuelle ?',
  'trial.survey.languagesPlaceholder': 'Sélectionnez un nombre de langues',
  'trial.survey.languagesQuestion': 'Combien de langues votre public parle-t-il ?',
  'trial.survey.submitError': "Impossible d'enregistrer vos réponses. Veuillez réessayer.",
  'trial.survey.subtitle': 'Deux questions rapides pour adapter votre espace de travail.',
  'trial.survey.title': 'Bienvenue sur Rask',
} satisfies TrialTranslation;

const it = {
  'trial.booking.bookedDescription': 'Controlla la posta, accetta l’invito e ci vediamo presto!',
  'trial.booking.bookedSnackbar': 'La tua demo è prenotata — a presto!',
  'trial.booking.bookedTitle': 'La tua demo è prenotata!',
  'trial.booking.calendarSubtitle':
    "Riceverai una panoramica personalizzata del prodotto, scoprirai storie di successo comprovate dei nostri clienti e conoscerai i prezzi più adatti al tuo caso d'uso.",
  'trial.booking.calendarTitle': 'Prenota la tua demo Rask di 30 minuti',
  'trial.booking.done': 'Fatto',
  'trial.booking.maybeLater': 'Forse più tardi',
  'trial.demo.description':
    'Seleziona la lingua di destinazione e guarda il risultato. Modifica i contenuti e regola le voci per esplorare l’editor.',
  'trial.demo.openEditor': "Apri nell'editor",
  'trial.demo.paidLanguages': 'Lingue disponibili con i piani a pagamento',
  'trial.demo.projectLabel': 'Progetto demo',
  'trial.demo.title': 'Prova gratuitamente il progetto demo!',
  'trial.demo.translateOwnVideo': 'Traduci il tuo video',
  'trial.demoBanner.delegate.cta': 'Lascia fare a noi',
  'trial.demoBanner.delegate.subtitle': 'Scopri come in una chiamata di 30 minuti con il nostro team.',
  'trial.demoBanner.delegate.title': 'Vuoi delegarci il lavoro di localizzazione?',
  'trial.demoBanner.integration.cta': "Ho bisogno di un'integrazione",
  'trial.demoBanner.integration.subtitle': 'Prenota una demo individuale e penseremo noi al resto.',
  'trial.demoBanner.integration.title': 'Integra facilmente Rask nel tuo flusso di lavoro',
  'trial.demoBanner.volume.cta': 'Riduci costi e impegno',
  'trial.demoBanner.volume.subtitle': 'Prenota una demo individuale e creeremo il tuo piano di localizzazione.',
  'trial.demoBanner.volume.title': 'Produci grandi volumi?',
  'trial.landing.durationMinutes': '{count} min',
  'trial.landing.durationSeconds': '{count} sec',
  'trial.landing.fileFallback': 'Il tuo file',
  'trial.landing.localizing': 'Localizzazione in corso',
  'trial.landing.previewAlt': 'Anteprima',
  'trial.landing.uploaded': 'Caricato',
  'trial.player.enterFullscreen': 'Attiva schermo intero',
  'trial.player.exitFullscreen': 'Esci da schermo intero',
  'trial.player.lipSync': 'Sincronizzazione labiale',
  'trial.player.localized': 'Localizzato',
  'trial.player.mute': 'Disattiva audio',
  'trial.player.original': 'Originale',
  'trial.player.pause': 'Metti in pausa',
  'trial.player.pauseVideo': 'Metti in pausa il video',
  'trial.player.play': 'Riproduci',
  'trial.player.playVideo': 'Riproduci video',
  'trial.player.previewAria': 'Anteprima del video {name}',
  'trial.player.seek': 'Scorri il video',
  'trial.player.unmute': 'Attiva audio',
  'trial.player.upgrade.continueWatching': 'Continua a guardare',
  'trial.player.upgrade.lockedSubtitle':
    'Abbiamo tradotto il primo minuto. Passa a un piano superiore per tradurre tutto il video, senza filigrana.',
  'trial.player.upgrade.lockedTitle': 'L’anteprima termina qui — sblocca il video completo',
  'trial.player.upgrade.oneMinutePreview': 'Anteprima di 1 minuto',
  'trial.player.upgrade.overlaySubtitle':
    'Ti piace l’anteprima? Passa a un piano superiore per tradurre tutto il video, senza filigrana.',
  'trial.player.upgrade.overlayTitle': 'Passa a un piano superiore per tradurre il video completo',
  'trial.player.upgrade.replay': 'Riproduci di nuovo l’anteprima',
  'trial.player.upgrade.seePlans': 'Vedi i piani',
  'trial.player.upgrade.upgrade': 'Fai upgrade',
  'trial.player.videoLanguage': 'Lingua del video',
  'trial.player.videoProgress': 'Avanzamento del video',
  'trial.preview.editorDescription': 'Perfeziona autonomamente copione, voci e sincronizzazione.',
  'trial.preview.editorTitle': "Esplora nell'editor",
  'trial.preview.export': 'Esporta',
  'trial.preview.exportDescription': 'Scarica il file MP4 localizzato con audio doppiato e sottotitoli.',
  'trial.preview.exportTitle': 'Esporta il tuo video',
  'trial.preview.openEditor': "Apri l'editor",
  'trial.preview.talkToSales': 'Parla con il team commerciale per il doppiaggio su larga scala',
  'trial.processing.audioReady': 'Il tuo file è pronto',
  'trial.processing.audioReadyDescription': 'Il file localizzato è pronto per essere visualizzato.',
  'trial.processing.completeAnnouncement': 'Localizzazione completata. Tutti i passaggi sono terminati.',
  'trial.processing.currentStepAnnouncement': 'Passaggio di elaborazione corrente: {step}',
  'trial.processing.localizedInto': 'Localizzato in {language}',
  'trial.processing.localizingAudio': 'Localizzazione del file',
  'trial.processing.localizingInto': 'Localizzazione in {language}',
  'trial.processing.localizingVideo': 'Localizzazione del video',
  'trial.processing.progressAria': 'Avanzamento della localizzazione: {percent}%',
  'trial.processing.steps.backgroundAudio.description': 'Conservazione della musica e dei suoni ambientali.',
  'trial.processing.steps.backgroundAudio.title': 'Audio di sottofondo mantenuto',
  'trial.processing.steps.speaker.description': 'Separazione della voce di ogni locutore dal mix di sottofondo.',
  'trial.processing.steps.speaker.title': 'Locutori identificati',
  'trial.processing.steps.timing.description': 'Allineamento di ogni frase ai tempi del parlato nel video.',
  'trial.processing.steps.timing.title': 'Sincronizzato con i tempi originali',
  'trial.processing.steps.translation.description':
    'Adattamento di espressioni, tono e formulazione al pubblico, non parola per parola.',
  'trial.processing.steps.translation.title': 'Tradotto nella lingua di destinazione',
  'trial.processing.steps.translation.titleWithLanguage': 'Tradotto in {language}',
  'trial.processing.steps.voice.description': 'Ricreazione del tono di ogni locutore nella nuova lingua.',
  'trial.processing.steps.voice.title': 'Voce di ogni locutore clonata',
  'trial.processing.videoReady': 'Il tuo video è pronto',
  'trial.processing.videoReadyDescription': 'Il video localizzato è pronto per essere visualizzato.',
  'trial.processing.waitDescription': 'Ci vuole circa un minuto. Il risultato apparirà qui.',
  'trial.processing.workingOnAudio': 'Elaborazione del file',
  'trial.processing.workingOnVideo': 'Elaborazione del video',
  'trial.publicShare.branding': 'Localizzato con Rask',
  'trial.publicShare.ctaQuestion': 'Vuoi localizzare il tuo video?',
  'trial.publicShare.description': 'Guardalo nella lingua originale o passa alla versione localizzata.',
  'trial.publicShare.heading': 'Questo video è stato localizzato con Rask',
  'trial.publicShare.loadErrorDescription': 'Aggiorna la pagina o riprova tra qualche istante.',
  'trial.publicShare.loadErrorTitle': 'Impossibile caricare questo video',
  'trial.publicShare.loading': 'Caricamento del video…',
  'trial.publicShare.loadingAria': 'Caricamento del video condiviso',
  'trial.publicShare.metaTitle': 'Video localizzato',
  'trial.publicShare.noCard': 'Localizza un video in oltre 135 lingue, senza carta di credito.',
  'trial.publicShare.playerAria': 'Lettore video {name}',
  'trial.publicShare.raskHome': 'Home di Rask',
  'trial.publicShare.sharedVideo': 'condiviso',
  'trial.publicShare.tryFree': 'Prova Rask gratis',
  'trial.publicShare.viewPlans': 'Visualizza i piani',
  'trial.share.button': 'Condividi',
  'trial.share.copied': 'Copiato!',
  'trial.share.copy': 'Copia',
  'trial.share.description': 'Invia il tuo video a chi vuoi usando il link qui sotto',
  'trial.share.error': 'Qualcosa è andato storto. Riprova più tardi.',
  'trial.share.title': 'Condividi il tuo video',
  'trial.sidebarBanner.cta': 'Passa alla versione completa',
  'trial.sidebarBanner.title': 'Sblocca le funzioni avanzate e porta le tue traduzioni video a un livello superiore!',
  'trial.survey.continue': 'Continua',
  'trial.survey.continueAnyway': 'Continua comunque',
  'trial.survey.footnote': 'Bastano 5 secondi per configurare al meglio il tuo spazio',
  'trial.survey.hours.fifteenToThirty': '15–30 ore',
  'trial.survey.hours.lessThanOne': 'Meno di 1 ora',
  'trial.survey.hours.moreThanThirty': 'Più di 30 ore',
  'trial.survey.hours.oneToTen': '1–10 ore',
  'trial.survey.hours.tenToFifteen': '10–15 ore',
  'trial.survey.hoursPlaceholder': 'Seleziona il volume',
  'trial.survey.hoursQuestion': 'Quanto è grande la tua videoteca attuale?',
  'trial.survey.languagesPlaceholder': 'Seleziona il numero di lingue',
  'trial.survey.languagesQuestion': 'Quante lingue parla il tuo pubblico?',
  'trial.survey.submitError': 'Non è stato possibile salvare le risposte. Riprova.',
  'trial.survey.subtitle': 'Due domande rapide per personalizzare il tuo spazio di lavoro.',
  'trial.survey.title': 'Ti diamo il benvenuto su Rask',
} satisfies TrialTranslation;

const ru = {
  'trial.booking.bookedDescription': 'Проверьте почту, примите приглашение — и до встречи!',
  'trial.booking.bookedSnackbar': 'Демо забронировано — до встречи!',
  'trial.booking.bookedTitle': 'Демо забронировано!',
  'trial.booking.calendarSubtitle':
    'Вы получите персональную демонстрацию продукта, узнаете об историях успеха наших клиентов и ценах для вашей задачи.',
  'trial.booking.calendarTitle': 'Забронируйте 30-минутное демо Rask',
  'trial.booking.done': 'Готово',
  'trial.booking.maybeLater': 'Возможно, позже',
  'trial.demo.description':
    'Выберите язык перевода и оцените результат. Изменяйте текст и настраивайте голоса, чтобы ознакомиться с возможностями редактора.',
  'trial.demo.openEditor': 'Открыть в редакторе',
  'trial.demo.paidLanguages': 'Языки, доступные на платных тарифах',
  'trial.demo.projectLabel': 'Демо-проект',
  'trial.demo.title': 'Попробуйте демопроект бесплатно!',
  'trial.demo.translateOwnVideo': 'Перевести своё видео',
  'trial.demoBanner.delegate.cta': 'Доверьте это нам',
  'trial.demoBanner.delegate.subtitle': 'Узнайте подробности на 30-минутной встрече с нашей командой.',
  'trial.demoBanner.delegate.title': 'Хотите поручить нам локализацию?',
  'trial.demoBanner.integration.cta': 'Мне нужна интеграция',
  'trial.demoBanner.integration.subtitle': 'Забронируйте личное демо — остальное мы возьмём на себя.',
  'trial.demoBanner.integration.title': 'Легко интегрируйте Rask в свой рабочий процесс',
  'trial.demoBanner.volume.cta': 'Сократить расходы и усилия',
  'trial.demoBanner.volume.subtitle': 'Забронируйте личное демо — мы составим план локализации.',
  'trial.demoBanner.volume.title': 'Работаете с большими объёмами?',
  'trial.landing.durationMinutes': '{count} мин',
  'trial.landing.durationSeconds': '{count} с',
  'trial.landing.fileFallback': 'Ваш файл',
  'trial.landing.localizing': 'Локализация',
  'trial.landing.previewAlt': 'Предпросмотр',
  'trial.landing.uploaded': 'Загружено',
  'trial.player.enterFullscreen': 'Перейти в полноэкранный режим',
  'trial.player.exitFullscreen': 'Выйти из полноэкранного режима',
  'trial.player.lipSync': 'Липсинк',
  'trial.player.localized': 'Перевод',
  'trial.player.mute': 'Выключить звук',
  'trial.player.original': 'Оригинал',
  'trial.player.pause': 'Приостановить',
  'trial.player.pauseVideo': 'Приостановить видео',
  'trial.player.play': 'Воспроизвести',
  'trial.player.playVideo': 'Воспроизвести видео',
  'trial.player.previewAria': 'Предпросмотр видео — {name}',
  'trial.player.seek': 'Перемотать видео',
  'trial.player.unmute': 'Включить звук',
  'trial.player.upgrade.continueWatching': 'Продолжить просмотр',
  'trial.player.upgrade.lockedSubtitle':
    'Мы перевели первую минуту. Перейдите на платный тариф, чтобы перевести видео целиком и без водяного знака.',
  'trial.player.upgrade.lockedTitle': 'Предпросмотр завершён — откройте полное видео',
  'trial.player.upgrade.oneMinutePreview': 'Предпросмотр 1 минуты',
  'trial.player.upgrade.overlaySubtitle':
    'Нравится результат? Перейдите на платный тариф, чтобы перевести видео целиком и без водяного знака.',
  'trial.player.upgrade.overlayTitle': 'Переведите видео целиком на платном тарифе',
  'trial.player.upgrade.replay': 'Посмотреть превью снова',
  'trial.player.upgrade.seePlans': 'Посмотреть тарифы',
  'trial.player.upgrade.upgrade': 'Перейти на платный тариф',
  'trial.player.videoLanguage': 'Версия видео',
  'trial.player.videoProgress': 'Ход воспроизведения',
  'trial.preview.editorDescription': 'Самостоятельно настройте текст, голоса и тайминг.',
  'trial.preview.editorTitle': 'Попробовать в редакторе',
  'trial.preview.export': 'Экспортировать',
  'trial.preview.exportDescription': 'Скачайте переведённое MP4-видео с дубляжом и субтитрами.',
  'trial.preview.exportTitle': 'Экспортировать видео',
  'trial.preview.openEditor': 'Открыть редактор',
  'trial.preview.talkToSales': 'Обсудить с отделом продаж массовый дубляж',
  'trial.processing.audioReady': 'Ваш файл готов',
  'trial.processing.audioReadyDescription': 'Переведённый файл готов к прослушиванию.',
  'trial.processing.completeAnnouncement': 'Локализация завершена. Все этапы обработки выполнены.',
  'trial.processing.currentStepAnnouncement': 'Текущий этап обработки: {step}',
  'trial.processing.localizedInto': 'Перевод на {language} готов',
  'trial.processing.localizingAudio': 'Локализуем ваш файл',
  'trial.processing.localizingInto': 'Переводим на {language}',
  'trial.processing.localizingVideo': 'Локализуем ваше видео',
  'trial.processing.progressAria': 'Ход локализации: {percent}%',
  'trial.processing.steps.backgroundAudio.description': 'Сохраняем музыку и фоновые звуки.',
  'trial.processing.steps.backgroundAudio.title': 'Сохранили фоновый звук',
  'trial.processing.steps.speaker.description': 'Отделяем голос каждого спикера от фоновой дорожки.',
  'trial.processing.steps.speaker.title': 'Определили спикеров',
  'trial.processing.steps.timing.description': 'Синхронизируем каждую реплику с видео.',
  'trial.processing.steps.timing.title': 'Сохранили оригинальный тайминг',
  'trial.processing.steps.translation.description':
    'Адаптируем выражения, тон и формулировки для аудитории, а не переводим дословно.',
  'trial.processing.steps.translation.title': 'Перевели на целевой язык',
  'trial.processing.steps.translation.titleWithLanguage': 'Перевели на {language}',
  'trial.processing.steps.voice.description': 'Воссоздаём голос каждого спикера на новом языке.',
  'trial.processing.steps.voice.title': 'Клонировали голос каждого спикера',
  'trial.processing.videoReady': 'Ваше видео готово',
  'trial.processing.videoReadyDescription': 'Переведённое видео готово к просмотру.',
  'trial.processing.waitDescription': 'Это займёт около минуты. Результат появится здесь.',
  'trial.processing.workingOnAudio': 'Обрабатываем ваш файл',
  'trial.processing.workingOnVideo': 'Обрабатываем ваше видео',
  'trial.publicShare.branding': 'Локализовано с помощью Rask',
  'trial.publicShare.ctaQuestion': 'Хотите локализовать своё видео?',
  'trial.publicShare.description': 'Посмотрите оригинал или переключитесь на локализованную версию.',
  'trial.publicShare.heading': 'Это видео локализовано с помощью Rask',
  'trial.publicShare.loadErrorDescription': 'Обновите страницу или повторите попытку через несколько секунд.',
  'trial.publicShare.loadErrorTitle': 'Не удалось загрузить видео',
  'trial.publicShare.loading': 'Загрузка видео…',
  'trial.publicShare.loadingAria': 'Загружаем опубликованное видео',
  'trial.publicShare.metaTitle': 'Локализованное видео',
  'trial.publicShare.noCard': 'Переводите видео более чем на 135 языков без банковской карты.',
  'trial.publicShare.playerAria': 'Видеоплеер «{name}»',
  'trial.publicShare.raskHome': 'Главная страница Rask',
  'trial.publicShare.sharedVideo': 'Видео, которым поделились',
  'trial.publicShare.tryFree': 'Попробовать Rask бесплатно',
  'trial.publicShare.viewPlans': 'Посмотреть тарифы',
  'trial.share.button': 'Поделиться',
  'trial.share.copied': 'Скопировано!',
  'trial.share.copy': 'Копировать',
  'trial.share.description': 'Отправьте видео кому угодно с помощью ссылки ниже',
  'trial.share.error': 'Что-то пошло не так. Повторите попытку позже.',
  'trial.share.title': 'Поделиться видео',
  'trial.sidebarBanner.cta': 'Перейти на полную версию',
  'trial.sidebarBanner.title': 'Откройте расширенные функции и выведите перевод видео на новый уровень!',
  'trial.survey.continue': 'Продолжить',
  'trial.survey.continueAnyway': 'Всё равно продолжить',
  'trial.survey.footnote': 'Займёт 5 секунд и поможет нам всё настроить',
  'trial.survey.hours.fifteenToThirty': '15–30 часов',
  'trial.survey.hours.lessThanOne': 'Менее 1 часа',
  'trial.survey.hours.moreThanThirty': 'Более 30 часов',
  'trial.survey.hours.oneToTen': '1–10 часов',
  'trial.survey.hours.tenToFifteen': '10–15 часов',
  'trial.survey.hoursPlaceholder': 'Выберите объём',
  'trial.survey.hoursQuestion': 'Сколько часов видео вы обрабатываете в месяц?',
  'trial.survey.languagesPlaceholder': 'Выберите количество языков',
  'trial.survey.languagesQuestion': 'На скольких языках говорит ваша аудитория?',
  'trial.survey.submitError': 'Не удалось сохранить ответы. Попробуйте ещё раз.',
  'trial.survey.subtitle': 'Два коротких вопроса, чтобы настроить рабочее пространство.',
  'trial.survey.title': 'Добро пожаловать в Rask',
} satisfies TrialTranslation;

export const TRIAL_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });
